export default __webpack_public_path__ + "static/media/mon-brick-img.97793bbe.webp";